import { armedConflictItems } from '.'
import { ContentsTable, SectionTitle, TopWave } from '../../../components'

export const NationalFront = () => {
	return (
		<div className='homeCard'>
			<TopWave />
			<SectionTitle title='Frente Nacional' />
			<ContentsTable items={armedConflictItems} />
			<div
				className='subjectCard mb-5 ownShadow'
				data-aos='fade-up'
				data-aos-duration='700'
				data-aos-once='true'
			>
				<div>
					<h4>Antecedentes</h4>
					<h5>Dictadura de Rojas Pinilla</h5>
					<p>
						Gustavo Rojas Pinilla quien ascendió al poder el 13 de junio de
						1953, se tomó las riendas del país por medio de un golpe de Estado
						apoyado por los liberales, quienes consideraron que una política
						militar sería la única solución a la situación violenta de la
						nación. El general en su mandato tenía tendencias populistas y un
						discurso orientado a las reformas sociales con carácter
						nacionalista.
						<br />
						<br />
						Llevó a cabo construcciones y proyectos tales como:
					</p>
					<ul>
						<li>El aeropuerto internacional El Dorado.</li>
						<li>El Hospital Militar Central.</li>
						<li>La televisión a blanco y negro en el país.</li>
						<li>El voto a la mujer colombiana.</li>
					</ul>
					<br />
					<p>
						Sin embargo, su gobierno se caracterizó por tener conductas
						opresivas respecto a la opinión pública y la prensa, lo que generó
						una inconformidad que lo forzó a renunciar el 10 de mayo de 1957
						dejando en delicadas condiciones a Colombia en manos de una Junta
						Militar conformada por los mayores generales de la época: Gabriel
						París y Deogracias Fonseca, el contraalmirante Rubén Piedrahita y
						los brigadieres generales Rafael Navas Pardo y Luis E. Ordóñez.
					</p>
				</div>
				<hr />

				<div>
					<h4>¿En qué consistió?</h4>

					<p>
						El Frente Nacional fue un pacto bipartidista que tuvo lugar desde el
						7 de agosto de 1958 hasta la misma fecha de 1974, entre los partidos
						tradicionales de la época: liberal y conservador; con el fin de
						reorganizar al país luego del controvertido y violento mandato
						dictatorial de la junta militar de Gustavo Rojas Pinilla (1953-1958)
						y calmar las tensiones entre partidos políticos, las cuales
						incrementaron con el magnicidio de Jorge Eliecer Gaitán en 1948.
					</p>
					<h4>Acuerdos precedentes al Frente Nacional</h4>
					<p>
						Alberto Lleras Camargo, líder del partido Liberal y Laureano Gómez,
						líder del partido Conservador se reunieron en 1956 en Benidorm,
						España a discutir distintas maneras de devolver la unidad al país, a
						este primer pacto se le denomino Acuerdo de Benidorm, luego, en 1957
						se celebró otra reunión en el mismo país, pero en Sitges, en el que
						se formalizaron los acuerdos iniciados en Benidorm, este pacto
						recibió el nombre de Acuerdo de Sitges, entre sus propuestas se
						destacan:
					</p>
					<ul>
						<li>
							Los partidos Liberal y Conservador se alternarían la presidencia
							cada cuatro años (aunque al principio se propuso que esto tuviera
							una duración de doce años, se prolongó a dieciséis).
						</li>
						<li>Se le otorgó el derecho al sufragio a la mujer.</li>
						<li>
							Cualquier otro grupo político diferente a los dos tradicionales no
							tendrían participación política.
						</li>
						<li>
							Dio origen a la carrera administrativa para educar a los futuros
							representantes estatales.
						</li>
						<li>Las instituciones se dividirían entre los dos partidos.</li>
					</ul>
					<br />
					<p>
						Las propuestas fueron aceptadas por medio de un plebiscito que se
						llevó a cabo el 1 de diciembre de 1957 con la participación
						histórica de 4 millones de colombianos.
					</p>
				</div>
				<br />
				<div>
					<h5>Alberto Lleras Camargo (1958-1962)</h5>
					<p>
						Fue el primer presidente del Frente Nacional, representando al
						partido liberal. Conocido por establecer un gobierno participativo
						para liberales y conservadores.
					</p>
					<ul>
						<li>
							Llevó a cabo una reforma agraria que buscó detener el traslado del
							campo a las zonas urbanas.
						</li>
						<li>
							Incentivó a la construcción de centrales eléctricas y proyectos de
							vivienda creando para esto el Instituto de Crédito Territorial.
						</li>
						<li>
							Hizo una reforma constitucional que fue la que alargó el Frente
							Nacional de 12 a 16 años.{' '}
						</li>
						<li>
							Fomentó la inversión extranjera, la industrialización por medio de
							subsidios y la educación.
						</li>
						<li>Creó el ministerio de educación nacional.</li>
					</ul>
					<br />
					<p>
						Su periodo presidencial es conocido como una época de cambio y
						transformación para Colombia. Pero su gobierno se vio afectado por
						la Segunda Guerra Mundial y la baja del precio del café como
						consecuencia de esta; las medidas que el presidente tomó al respecto
						fueron fuertemente polémicas.{' '}
					</p>
				</div>
				<div>
					<h5>Guillermo León Valencia (1962-1966)</h5>
					<img src='/img/guillermoLeonValencia.png' alt='Guillermo León Valencia' className='w-25 rounded mx-auto d-block' />
					<p>
						Segundo presidente del Frente Nacional, perteneciente al partido
						conservador. En su gobierno enfrentó problemas sociales y de orden
						público como consecuencia de las fuerzas que tomaban las guerrillas,
						a pesar de los esfuerzos que este hizo por contrarrestar la
						violencia, en su periodo presidencial se crearon movimientos con
						ideologías comunistas tal como las FARC.
					</p>
					<ul>
						<li>
							Colombia se unió al pacto andino (Alianza entre países de América
							del Sur).
						</li>
						<li>
							Realizó una gran política exterior buscando fortalecer las
							relaciones diplomáticas e internacionales.
						</li>
						<li>Creó el instituto Colombiano de reforma agraria. (ENCORA)</li>
					</ul>
					<br />
					<p>
						Si bien, estos aspectos impulsaron el desarrollo del país, la
						economía colombiana y la calidad de vida continuaron siendo débil.
					</p>
				</div>
				<div>
					<h5>Carlos Lleras Restrepo (1966-1970)</h5>
					<img src='/img/carlosLlerasRestrepo.png' alt='Carlos Lleras Restrepo' className='w-25 rounded mx-auto d-block' />
					<p>
						Fue el tercer presidente del Frente Nacional, siendo parte del
						partido Liberal. Su gobierno es criticado porque se vio favorecida
						la corrupción al entregar auxilios a los parlamentarios sin
						fiscalización y por la violencia sin control, resaltando la masacre
						de los estudiantes de la Universidad Nacional en 1968.
					</p>
					<ul>
						<li>
							Estableció un sistema de seguridad social que incluía seguro de
							salud, pensiones y atención médica gratuita para los más
							vulnerables.
						</li>
						<li>Modernizó la infraestructura del país.</li>
						<li>
							Reformas constitucionales que exigían la presentación de un plan
							de desarrollo por parte de los presidentes.
						</li>
						<li>Creó los Institutos Nacionales de Educación Media (INEM)</li>
						<li>
							Durante su gobierno se construyeron aeropuertos y carreteras que
							facilitaron la entrada y salida de bienes y productos en el país.
						</li>
						<li>Creó el ICBF y el ICFES.</li>
					</ul>
				</div>
				<div>
					
					<h5>Misael Pastrana Borrero (1970-1974)	</h5>
					<img src='/img/misaelPastrana.png' alt='Misael Pastrana Borrero' className='w-25 rounded mx-auto d-block'/>
					<p>
						El último presidente del Frente Nacional fue este Conservador.
						Recibió fuertes críticas por su política económica que aumentó la
						inflación y el nivel de desempleo en el país y su ineficiente lucha
						para proteger los derechos y combatir a las guerrillas.
					</p>
					<ul>
						<li>Promovió la migración del campo a la ciudad.</li>
						<li>
							Incentivó la construcción a través de las Unidades de Poder
							Adquisitivo Constante, UPAC.
						</li>
						<li>
							Creó la constitución política de Colombia de 1971 en la cual creó
							la creación del tribunal constitucional, la garantía de los
							derechos fundamentales y la institucionalización de la
							participación ciudadana.
						</li>
						<li>
							Su economía se basó en la apertura al comercio internacional.
						</li>
					</ul>
				</div>

				<br />

				<div>
					<h4>Consecuencias del Frente Nacional</h4>
					<ul>
						<li>
							Exclusión a las minorías puesto a que únicamente se tenía en
							cuenta a los partidos tradicionales, demostrando así que a pesar
							de los avances económicos el frente nacional no respondía a la
							crisis social y política de esa década.{' '}
						</li>
						<li>
							Aumentó la acción y presencia de grupos armados, formando así
							nuevas guerrillas y narcotráfico.{' '}
						</li>
						<li>La violencia bipartidista disminuyó debido a esta coalición</li>
						<li>
							Los partidos políticos se dividieron igualmente de manera interna.
						</li>
						<li>
							La crisis económica aumentó considerablemente y debido a préstamos
							que se tuvieron que hacer con entidades como el Banco Mundial, la
							situación para el pueblo empeoró debido a la inflación.
						</li>
					</ul>
				</div>
				<hr />
				<h5>Bibliografía</h5>
				<ul>
					<li>
						7 consecuencias del Frente Nacional de Colombia. (2022, noviembre
						22). Lifeder.
						https://www.lifeder.com/<br />consecuencias-frente-nacional-colombia/
					</li>
					<li>
						Memoria, S. (2023, agosto 8). ¿Qué fue el Frente Nacional? Señal
						Memoria. <br />
						<small>https://www.senalmemoria.co/<br />articulos/que-fue-el-frente-nacional</small>
					</li>
					<li>
						Memoria, S. (2021, marzo 15). Gustavo Rojas Pinilla / Junta Militar
						de Gobierno. Señal Memoria.
						https://www.senalmemoria.co/la-voz-del-poder/gustavo-rojas-pinilla
					</li>
					<li>
						El golpe militar de Gustavo Rojas Pinilla. (s. f.). Informe Final -
						Comisión de la Verdad. Recuperado 6 de julio de 2024, de López, L.
						P. E. [@laprofeelianalopez2040]. (2020, septiembre 8). Historia |
						Frente nacional en Colombia, consecuencias y oposición (guerrillas).
						Youtube. https://www.youtube.com/watch?v=2OCBTgzoNG0
					</li>
					<li>
						Clase, S. [@socialclase9341]. (2020, agosto 18). EL FRENTE NACIONAL.
						Youtube. https://www.youtube.com/watch?v=TswsFkSOD5U
					</li>
					<li>
						Chilito, A. [@AdrianaChilito]. (2023, mayo 21). El FRENTE NACIONAL
						en Colombia. Youtube. https://www.youtube.com/watch?v=LkpBx2JpLfo
					</li>
				</ul>
			</div>
		</div>
	)
}
